import get from 'lodash/get'
import {createContext, useCallback, useContext, useMemo} from 'react'

import type {Messages} from '@/types'

export const MessageContext = createContext<Messages>({})

type GetMessage = (key: string, parameters?: Record<string, string>) => string

export default function useMessages(section?: string): GetMessage {
  const messages = useContext(MessageContext)
  return useCallback(
    (key: string, parameters?: Record<string, string>) => {
      const fullKey = section ? `${section}.${key}` : key
      const entry = get(messages, fullKey)
      if (typeof entry !== 'string')
        throw new Error(`Key ${fullKey} does not resolve to a string.`)
      return parameters ? replaceMessage(entry, parameters) : entry
    },
    [messages, section]
  )
}

export function useMessageList(key: string): string[] {
  const messages = useContext(MessageContext)
  return useMemo(() => {
    const entry = get(messages, key)
    if (!Array.isArray(entry))
      throw new Error(`Key ${key} did not resolve to a string array.`)
    return entry
  }, [messages, key])
}

function replaceMessage(msg: string, data: Record<string, string>) {
  return msg.replace(
    new RegExp('%\\((' + Object.keys(data).join('|') + ')\\)', 'g'),
    function (m, key) {
      return data.hasOwnProperty(key) ? data[key] : m
    }
  )
}
